
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/apipages/libraries/examples/python",
      function () {
        return require("private-next-pages/apipages/libraries/examples/python/index.jsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/apipages/libraries/examples/python"])
      });
    }
  